import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ReviewItemsService = {
    list: async () => axios.post(API_URL + "/reviewItems/list").then(({ data }) => data.data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + `/reviewItems/getById/${id}`).then(({ data }) => data).catch((err) => { throw err}),

    create: async (payload) => axios.post(API_URL + "/reviewItems", payload).then(({ data }) => data).catch((err) => { throw err}),

    update: async (id, payload) => axios.put(API_URL + `/reviewItems/${id}`, payload).then(({ data }) => data).catch((err) => { throw err}),

    delete: async (id) => axios.delete(API_URL + `/reviewItems/${id}`).then(({ data }) => data).catch((err) => { throw err}),

    getAll: async () => axios.get(API_URL + `/vehicles/options/reviewItems`).then(({ data }) => data.data).catch((err) => { throw err}),
};

export default ReviewItemsService;